<template>
    <div>
        <v-data-table :headers="headers" :items="spiele" mobile-breakpoint="1" hide-default-footer
                      group-by="liga" disable-pagination :search="search"
                      :class="[{'ma-2 elevation-4': $vuetify.breakpoint.mdAndUp}]">
            <template v-slot:group.header="{ group }" >
                <th :colspan="colSpanGroup" style="position: relative"
                    :class="[{'text-center': $vuetify.breakpoint.mdAndUp},
                              'white--text grey darken-2 body-2 font-weight-medium']">
                    {{group}}
                </th>
            </template>
            <template v-slot:header.vs="{}">
                <th class="px-0"></th>
            </template>
            <template v-slot:item="{ item }">
                <tr>
                    <td class="pr-0" v-if="type==='live'">
                        <span v-if="item.saison.rundeText">{{item.saison.rundeText}}</span>
                        <span v-else-if="item.saison.isCup">{{item.saison.runde}}</span>
                        <span v-else>{{item.runde}}{{item.saison.rundeText}}</span>
                    </td>
                    <td class="pr-0 text-right">
                        <v-hover v-slot="{ hover }">
                            <tab-teams-with-icons :item="item" type="heim" @filtered="quickSearch"
                                                  :class="{ 'primary--text': hover }">
                            </tab-teams-with-icons>
                        </v-hover>
                    </td>
                    <td class="text-center">{{item.vs}}</td>
                    <td class="pl-0">
                        <v-hover v-slot="{ hover }">
                            <tab-teams-with-icons :item="item" type="gast" @filtered="quickSearch"
                                                  :class="{ 'primary--text': hover }">
                            </tab-teams-with-icons>
                        </v-hover>
                    </td>
                    <td v-if="!isCup">{{item.tabPktResult}}</td>
                    <td v-if="!isCup">{{item.mpResult}}</td>
                    <td v-if="!isCup">{{item.spResult}}</td>
                    <td v-if="isCup" class="text-center text-no-wrap">{{item.fwResult}}</td>
                    <td v-if="isCup" class="text-center text-no-wrap">{{item.arResult}}</td>
                    <td class="px-0 text-center">
                        <div style="white-space: nowrap">
                            {{item.kegelResult}}
                        </div>
                    </td>
                    <td class="text-center" v-if="!noActions">
                        <div style="white-space: nowrap">
                            <v-btn v-if="item.infos.stream"
                                   @click="openStream(item.infos.stream)" icon class="d-inline-block">
                                <v-icon :color="item.vereine.heim.indexOf('pending') !== -1?'blue':''">mdi-video-box</v-icon>
                            </v-btn>
                            <v-btn icon @click="openSpielbericht(item)">
                                <v-icon>mdi-file-document-outline</v-icon>
                            </v-btn>
                        </div>
                    </td>
                    <td :class="[{'pl-0': !noActions}]">
                        <spiel-status-text :spiel="item" @filtered="quickSearch" :allow-hover="true">
                        </spiel-status-text>
                    </td>
                </tr>
            </template>
            <template v-slot:no-data>
                Bitte eine Runde wählen!
            </template>
        </v-data-table>
        <div :class="[{'pt-2 pl-3': $vuetify.breakpoint.smAndDown}, 'body-2']">
            <div :class="[{'d-inline-block ml-3': $vuetify.breakpoint.mdAndUp}]">
                <v-icon color="blue" small class="mr-1">mdi-star</v-icon>
                Mannschaftsrekord
            </div>
            <div :class="[{'d-inline-block ml-5': $vuetify.breakpoint.mdAndUp}]">
                <v-icon color="blue" small class="mr-1">mdi-account-star</v-icon>
                Einzelrekord
            </div>
            <div :class="[{'d-inline-block ml-5': $vuetify.breakpoint.mdAndUp}]">
                <v-icon color="error" small class="mr-1">mdi-alert</v-icon>
                Protest eingelegt
            </div>
            <!--<div :class="[{'d-inline-block ml-5': $vuetify.breakpoint.mdAndUp}]">
                <v-icon color="primary" small class="mr-1">mdi-alert</v-icon>
                Ergebnis abgelehnt
            </div>-->
        </div>
    </div>
</template>

<script>

    import SpielStatusText from "./components/spielStatusText";
    import TabTeamsWithIcons from "./components/tabTeamsWithIcons";

    export default {
        components: {
            TabTeamsWithIcons,
            SpielStatusText},
        name: "spiele-liste",
        props: ['headers', 'spiele', 'type', 'search', 'noActions', 'isCup'],
        computed: {
            colSpanGroup(){ return this.type === 'live' ? 10 : 9; }
        },
        methods: {
            openStream(url){
                window.open(url, '_blank').focus();
            },
            openSpielbericht(item){
                this.$emit('openSpielbericht', item);
            },
            quickSearch(content){
                this.$emit('quickSearch', content);
            },
        },
    }
</script>

<style scoped>
</style>